/**
 * composer function based on Eric Evans article. Please note that is a reduceRight therefore
 * the execution is in descending order
 * @example
 *  const add5 = x => x + 5;
 *  const double = x => x * 2;
 *
 *  cosnt add5AndDuplicate = compose(sum5, double);
 *
 *  console.log(add5AndDuplicate(1)); // 12
 *
 * @see https://medium.com/javascript-scene/composing-software-an-introduction-27b72500d6ea
 * @param fns
 * @return (x: T[]) => T[]
 */
export const compose =
  <T1 = any, T2 = any>(...fns: Function[]) =>
  (collection: T1): T2 =>
    fns.reduceRight((next, fn) => fn(next), collection);

/**
 * Converts string to number; if passed input isNaN returns undefined
 */
export const getNumberOrUndefined = compose(x => (isNaN(x) ? undefined : x), Number);
